<template>
    <v-app id="inspire">
        <Navigation></Navigation>
        <AppBar
                :title="pageTitle"
                :actions="appBarActions"
        />
        <v-content>

            <v-container fluid>


                <v-row>
                    <v-col md="10" lg="8">
                        <v-tabs
                                v-model="tabsModel"
                                dark
                                background-color="grey darken-3"
                        >
                            <v-tab :href="`#tab-info`">Info</v-tab>
                            <v-tab :href="`#tab-ppapikeys`">Landing Page API-keys</v-tab>

                            <v-tabs-items v-model="tabsModel">
                                <v-tab-item :value="`tab-info`">
                                    <UserInfo @alert="setAlert" :id="id" />
                                </v-tab-item>
                                <v-tab-item  :value="`tab-ppapikeys`">
                                    <UserLandingPageApiKeys @alert="setAlert" :id="id" />
                                </v-tab-item>
                            </v-tabs-items>
                        </v-tabs>

                    </v-col>
                </v-row>
            </v-container>

        </v-content>

        <v-snackbar
                v-model="snackbarShow"
                top
                right
                :timeout="4000"
                :color="snackbarColor"
        >
            {{ snackbarText }}
            <v-btn
                    x-small
                    text
                    fab
                    @click="snackbarShow = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>

    </v-app>
</template>
<script>

    import UserInfo from "./components/UserInfo";
    import UserLandingPageApiKeys from "./components/UserLandingPageApiKeys";

    export default {
        name: "UserEdit",
        components:{
            UserInfo,
            UserLandingPageApiKeys
        },
        props: {
            pageTitle: {
                type: String,
                default: 'Edit User'
            },
            id:{
                type: String,
                default: 0
            }
        },
        data(){
            return {
                appBarActions: [
                    {
                        title: "Add User",
                        icon: 'mdi-plus',
                        color: 'grey darken-2',
                        to: {  name: 'user/add' }
                    },
                    {
                        title: "Users",
                        icon: 'mdi-apps',
                        color: 'grey darken-2',
                        to: {  name: 'users' }
                    },
                ],
                snackbarColor: 'success',
                snackbarShow: false,
                snackbarText: '',

                // tabsModel: 'tab-info',
                tabsModel: 'tab-apikeys',
            }
        },
        methods:{

            setAlert( {type, message} ) {
                this.snackbarColor = type;
                this.snackbarText  = message;
                this.snackbarShow  = true;
            },
        }
    }
</script>